import React from 'react';
import i18n from '@leverege/i18n';
import { Pane, ToggleButton, Popup, NumericInput, Flex, Text } from '@leverege/ui-elements';
import classnames from 'classnames';
import S from './FontSizeSelector.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tfIcon
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.widgets.FontSize');
class Trigger extends React.Component {
  componentDidUpdate() {
    const {
      domRef,
      onToggle,
      isOpened
    } = this.props;
    const {
      x,
      y,
      width,
      height
    } = domRef?.current?.getBoundingClientRect() || {};
    if (!x && !y && !width && !height && isOpened) {
      setTimeout(onToggle());
    }
  }
  render() {
    const {
      active,
      onToggle,
      domRef,
      disabled
    } = this.props;
    return /*#__PURE__*/_jsx(ToggleButton, {
      title: t('title'),
      variant: "customTextFontSize|customText",
      disabled: disabled,
      value: active,
      onChange: onToggle,
      domRef: domRef,
      icon: tfIcon('button', 'fa-solid fa-text-size')
    });
  }
}
export default function FontSize(props) {
  const {
    onChange,
    value,
    context: {
      editor
    },
    active,
    disabled
  } = props;
  const numVal = parseInt(value) || 16;
  const renderSelector = () => {
    return /*#__PURE__*/_jsx(Pane, {
      variant: "customTextValueEditor",
      children: /*#__PURE__*/_jsxs(Flex, {
        direction: "row",
        align: "center",
        children: [/*#__PURE__*/_jsx(NumericInput, {
          className: classnames(S.pxInput, S.win),
          min: 1,
          max: 99,
          variant: "customTextFontSize|customText",
          value: numVal,
          onChange: ({
            value
          }) => onChange(value, editor)
        }), /*#__PURE__*/_jsx(Text, {
          variant: "pxInput",
          children: "px"
        })]
      })
    });
  };
  const renderTrigger = ({
    ref,
    onToggle,
    isOpened
  }) => {
    return /*#__PURE__*/_jsx(Trigger, {
      domRef: ref,
      onToggle: onToggle,
      isOpened: isOpened,
      active: active,
      disabled: disabled
    });
  };
  return /*#__PURE__*/_jsx(Popup, {
    variant: "customTextImageEditor|customText",
    render: renderSelector,
    trigger: renderTrigger,
    className: classnames(S.popup, S.win)
  });
}